import { getAllButRequiredWaiverQuestions } from '../../../containers/checkout/utils/typedUtils';
import { CheckoutState } from '../../../state';
import { getQuestionsForBuyer } from './getQuestionsForBuyer';

/**
 * @private Do not use this directly, derive information from `getSurvey` instead
 */
export const getAllButRequiredWaiverQuestionsForBuyer = (
    state: CheckoutState,
) => getAllButRequiredWaiverQuestions(getQuestionsForBuyer(state));
